$flyout-arrow-size: 12px;

:host {
  display: inline-block;
  --arrow-offset: #{$flyout-arrow-size};
  --arrow-from-left: calc(50% - #{$flyout-arrow-size});
}

.content {
  @apply relative;
  box-shadow: var(--shadow-elevation-middle);
  text-align: left;
  transition: opacity 0.15s linear;
  z-index: var(--layer-1500);
  max-height: 90vh;
  box-sizing: border-box;

  &.arrow {
    &:before {
      content: '';
      @apply absolute;
      background-color: transparent;
      width: 0;
      height: 0;
      left: var(--arrow-from-left);
    }

    &.top {
      &:before {
        bottom: -#{$flyout-arrow-size};
        border-left: #{$flyout-arrow-size} solid transparent;
        border-right: #{$flyout-arrow-size} solid transparent;
      }
    }

    &.right {
      &:before {
        left: -#{$flyout-arrow-size};
        top: calc(#{$flyout-arrow-size}/ 2);
        border-top: #{$flyout-arrow-size} solid transparent;
        border-bottom: #{$flyout-arrow-size} solid transparent;
      }
    }

    &.bottom {
      &:before {
        top: -#{$flyout-arrow-size};
        border-left: #{$flyout-arrow-size} solid transparent;
        border-right: #{$flyout-arrow-size} solid transparent;
      }
    }

    &.left {
      &:before {
        left: 100%;
        top: calc(#{$flyout-arrow-size}/ 2);
        border-top: #{$flyout-arrow-size} solid transparent;
        border-bottom: #{$flyout-arrow-size} solid transparent;
      }
    }
  }

  &.dark {
    @apply bg-gray-900 text-white;

    &.top {
      &:before {
        border-top: #{$flyout-arrow-size} solid var(--color-steel-900);
      }
    }

    &.right {
      &:before {
        border-right: #{$flyout-arrow-size} solid var(--color-steel-900);
      }
    }

    &.bottom {
      &:before {
        border-bottom: #{$flyout-arrow-size} solid var(--color-steel-900);
      }
    }

    &.left {
      &:before {
        border-left: #{$flyout-arrow-size} solid var(--color-steel-900);
      }
    }
  }

  &.light {
    @apply bg-white;
    &.top {
      &:before {
        border-top: #{$flyout-arrow-size} solid white;
      }
    }

    &.right {
      &:before {
        border-right: #{$flyout-arrow-size} solid white;
      }
    }

    &.bottom {
      &:before {
        border-bottom: #{$flyout-arrow-size} solid white;
      }
    }

    &.left {
      &:before {
        border-left: #{$flyout-arrow-size} solid white;
      }
    }
  }
}

.backdrop {
  @apply w-full h-full;
  top: 0;
  left: 0;
  background: rgba(58, 64, 70, 0.2);
  z-index: var(--layer-1500);
}
